import { createSlice } from '@reduxjs/toolkit';

// Chatbot state is intentionally ephemeral — not whitelisted in redux-persist
// (see store.js). A refresh resets the conversation, which is what we want.
const initialState = {
  isOpen: false,
  messages: [],        // [{ role: 'bot'|'user', text, candidates? }]
  isTyping: false,
  // Set to a full ChatbotTemplate snapshot when the user picks a candidate.
  // The builder subscribes, hydrates its working state, then clears this.
  pendingTemplate: null,
};

const chatbotSlice = createSlice({
  name: 'chatbot',
  initialState,
  reducers: {
    openChatbot: (state) => {
      state.isOpen = true;
    },
    closeChatbot: (state) => {
      state.isOpen = false;
    },
    toggleChatbot: (state) => {
      state.isOpen = !state.isOpen;
    },
    addMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    setTyping: (state, action) => {
      state.isTyping = action.payload;
    },
    setPendingTemplate: (state, action) => {
      state.pendingTemplate = action.payload;
    },
    clearPendingTemplate: (state) => {
      state.pendingTemplate = null;
    },
    resetChatbot: () => initialState,
  },
});

export const {
  openChatbot,
  closeChatbot,
  toggleChatbot,
  addMessage,
  setTyping,
  setPendingTemplate,
  clearPendingTemplate,
  resetChatbot,
} = chatbotSlice.actions;

export default chatbotSlice.reducer;
